import { useState, useEffect } from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, MessageCircle } from 'lucide-react'; // Added Tiktok/Social icons support if library has them, using MessageCircle for generic if needed or just specific ones
import { Link } from 'react-router-dom';
import { API_URL } from '../config/api';
import './Footer.css';

const Footer = () => {
    const [content, setContent] = useState({});

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const response = await fetch(`${API_URL}/content`);
                const data = await response.json();
                if (data.success) {
                    setContent(data.data);
                }
            } catch (error) {
                console.error('Error fetching footer content:', error);
            }
        };

        fetchContent();
    }, []);

    // Helper to get formatted content with fallback
    const get = (key, fallback) => content[key] || fallback;

    const ensureAbsoluteUrl = (url) => {
        if (!url) return '#';
        if (url.startsWith('http://') || url.startsWith('https://')) return url;
        return `https://${url}`;
    };

    return (
        <footer className="footer">
            <div className="container footer-container">
                <div className="footer-section">
                    <div className="footer-logo">
                        <img
                            src="/logo-white.png"
                            alt="GeneCenter"
                            className="footer-logo-img"
                        />
                    </div>
                    <p className="footer-tagline">
                        {get('contact.footer_tagline', 'Genética de precisión para diagnósticos confiables')}
                    </p>
                    <p className="footer-description">
                        {get('contact.footer_description', 'Comprometidos con la salud y el bienestar a través de diagnósticos genéticos precisos y asesoramiento humano.')}
                    </p>
                    <div className="social-links">
                        {content['contact.social_facebook'] && (
                            <a href={ensureAbsoluteUrl(content['contact.social_facebook'])} target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
                                <Facebook size={20} />
                            </a>
                        )}
                        {content['contact.social_instagram'] && (
                            <a href={ensureAbsoluteUrl(content['contact.social_instagram'])} target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
                                <Instagram size={20} />
                            </a>
                        )}
                        {content['contact.social_linkedin'] && (
                            <a href={ensureAbsoluteUrl(content['contact.social_linkedin'])} target="_blank" rel="noopener noreferrer" className="social-link" title="LinkedIn">
                                <Linkedin size={20} />
                            </a>
                        )}
                        {content['contact.social_tiktok'] && (
                            <a href={ensureAbsoluteUrl(content['contact.social_tiktok'])} target="_blank" rel="noopener noreferrer" className="social-link" title="TikTok">
                                <MessageCircle size={20} />
                            </a>
                        )}
                    </div>
                </div>

                <div className="footer-section">
                    <h3 className="footer-title">Enlaces Rápidos</h3>
                    <ul className="footer-links">
                        <li><Link to="/">Inicio</Link></li>
                        <li><Link to="/nosotros">Quiénes Somos</Link></li>
                        <li><Link to="/servicios">Servicios</Link></li>
                        <li><Link to="/pruebas">Pruebas Genéticas</Link></li>
                        <li><Link to="/blog">Blog Educativo</Link></li>
                    </ul>
                </div>

                <div className="footer-section">
                    <h3 className="footer-title">Servicios Destacados</h3>
                    <ul className="footer-links">
                        <li><Link to="/servicios">Consulta Especializada</Link></li>
                        <li><Link to="/pruebas">Análisis Genético</Link></li>
                    </ul>
                </div>

                <div className="footer-section">
                    <h3 className="footer-title">Contacto</h3>
                    <ul className="contact-info">
                        <li>
                            <MapPin size={18} />
                            <span>{get('contact.address', 'Av. Médica 123, Consultorio 405, Ciudad de México')}</span>
                        </li>
                        <li>
                            <Phone size={18} />
                            <span>{get('contact.phone', '+52 55 1234 5678')}</span>
                        </li>
                        <li>
                            <Mail size={18} />
                            <span>{get('contact.email', 'contacto@genecenter.com.mx')}</span>
                        </li>
                        {content['contact.whatsapp'] && (
                            <li>
                                <MessageCircle size={18} />
                                <a 
                                    href={`https://wa.me/${content['contact.whatsapp'].replace(/\D/g, '')}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="whatsapp-link"
                                >
                                    WhatsApp: {content['contact.whatsapp']}
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <p>&copy; {new Date().getFullYear()} GeneCenter. Todos los derechos reservados.</p>
                    <div className="legal-links">
                        <a href="/privacy-policy.html" className="footer-legal-link">Aviso de Privacidad</a>
                        <span className="footer-legal-separator"> | </span>
                        <a href="/terminos.html" className="footer-legal-link">Términos y Condiciones</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
